import { getService, postService } from '../../utilities/request/restPatientPortalClient'

export const postPatientConsent = (payload) => {
    return postService(`/patient_portal/appointment/patient-consent`, payload)
}